import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const ExtentEventApi = createApi({
  reducerPath: "extentEventApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    extendEventApi: builder.mutation({
      query: ({ eventId, newEndDate }) => ({
        url: "/admin/admin/extendEvent",
        method: "POST",
        body: {
          eventId,
          newEndDate
        }
      }),
      extraOptions: { service: "TMS" }
    }),
    extendSessionApi: builder.mutation({
      query: ({ eventId, newEndDate, sessionId }) => ({
        url: "/admin/admin/extendSession",
        method: "POST",
        body: {
          eventId,
          newEndDate,
          sessionId
        }
      }),
      extraOptions: { service: "TMS" }
    }),
    extendAgendaApi: builder.mutation({
      query: ({ eventId, newEndDate, sessionId, agendaId }) => ({
        url: "/admin/admin/extendAgenda",
        method: "POST",
        body: {
          eventId,
          newEndDate,
          sessionId,
          agendaId
        }
      }),
      extraOptions: { service: "TMS" }
    })
  })
});

export const {
  useExtendEventApiMutation,
  useExtendSessionApiMutation,
  useExtendAgendaApiMutation
} = ExtentEventApi;
